import { useState, useEffect } from 'react';
import Admin from './pages/Admin';
import './App.css';

function AdminApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState<string | null>(null);

  // Check if user is already logged in
  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    const userId = localStorage.getItem('userId');
    const role = localStorage.getItem('userRole');

    if (authToken && userId && role) {
      setIsLoggedIn(true);
      setUserRole(role);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    setIsLoggedIn(false);
    setUserRole(null);
  };

  const handleLoginSuccess = (role: string) => {
    setIsLoggedIn(true);
    setUserRole(role);
  };

  return (
    <div className="app" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header style={{ padding: '1rem 2rem', borderBottom: '1px solid #ddd' }}>
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h1 style={{ margin: 0, fontSize: '1.5rem' }}>Clinical Trial Expertise - Admin Portal</h1>
          {isLoggedIn && (
            <button
              onClick={handleLogout}
              style={{
                padding: '0.5rem 1rem',
                background: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Logout
            </button>
          )}
        </div>
      </header>

      <main style={{ flex: 1 }}>
        {isLoggedIn && userRole === 'admin' ? (
          <Admin userRole={userRole} />
        ) : (
          <Admin userRole={undefined} onLoginSuccess={handleLoginSuccess} />
        )}
      </main>

      <footer
        style={{ padding: '2rem', textAlign: 'center', borderTop: '1px solid #ddd', color: '#666' }}
      >
        <p>
          &copy; 2026 Clinical Trial Expertise, property of &copy; 2025 Xana (PTY) Ltd. All rights
          reserved.
        </p>
        <p>Expert Clinical Trial Consulting Services</p>
      </footer>
    </div>
  );
}

export default AdminApp;
